





















































  

import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import UpdateJobWorkerOfferRequest from '@/models/JobWorkerOffers/UpdateJobWorkerOfferRequest'
import JobWorkerOfferDto from '@/models/JobWorkerOffers/JobWorkerOfferDto';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import { AppModule } from '@/store/modules/app';
import JobWorkerStatus from '@/models/JobWorkers/JobWorkerStatus';
import UpdateJobWorkerPlacementRequest from '@/models/JobWorkerOffers/UpdateJobWorkerPlacementRequest';
import JobWorkerOfferStatus from '@/models/JobWorkerOffers/JobWorkerOfferStatus';

@Component({
    name: 'JobWorkerPlacementEdit'
})
export default class extends GiganautVueDialog {

    @Prop({required: true})
    jobWorkerOffer: JobWorkerOfferDto;
    // @Prop({required: true})
    // jobWorkerStatus: JobWorkerStatus;
    request: UpdateJobWorkerPlacementRequest = new UpdateJobWorkerPlacementRequest();

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            this.request = new UpdateJobWorkerPlacementRequest();
            this.request.startDate = new Date(this.jobWorkerOffer.startDate).toISOString().substr(0,10);
            this.request.fee = this.jobWorkerOffer.fee;
        }
    }

    get loading() {
        return JobDetailsModule.loadingDialog;
    }

    get showEdit() {
		return this.jobWorkerOffer.status === JobWorkerOfferStatus.Placed;
	}

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        this.request.jobWorkerOfferId = this.jobWorkerOffer.id;
        this.request.updatedAt = this.jobWorkerOffer.updatedAt;
        await JobDetailsModule.editJobWorkerPlacement(this.request);
        this.dialog = false;
    }
}
